import { Card, Grid, Typography } from "@material-ui/core";
import { blueGrey, purple } from "@material-ui/core/colors";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

const FormConfigCard = ({
  availableGroups,
  program,
  group,
  alertEnabled,
  formType,
  endDay,
  startDay,
  name,
}) => {
  const { i18n } = useTranslation();

  return (
    <Grid item xs={12}>
      <Card
        variant="outlined"
        style={{
          padding: 16,
          borderRadius: 16,
          border: "dotted",
          borderWidth: 2,
          borderColor: blueGrey[200],
          backgroundColor: purple[50],
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" style={{ color: "red" }}>
              Configuración del formulario, no visible para los rescatadores
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">
              {name[i18n.language.split("-")[0]]}
            </Typography>
          </Grid>
          <ConfigItem
            item="Programa"
            value={
              !!availableGroups[program] ? availableGroups[program].name : " --"
            }
          />
          <ConfigItem
            item="Grupo"
            value={
              !!availableGroups[program]
                ? availableGroups[program].groups[group].name
                : "--"
            }
          />
          <ConfigItem
            item="Reanibex Alert"
            value={alertEnabled ? "Si" : "No"}
          />
          <ConfigItem item="Tipo de formulario" value={formType} />
          <ConfigItem
            item="Inicio"
            value={moment(startDay).format("DD/MM/yyyy")}
          />
          <ConfigItem item="Fin" value={moment(endDay).format("DD/MM/yyyy")} />
        </Grid>
      </Card>
    </Grid>
  );
};

export default FormConfigCard;

const ConfigItem = ({ item, value }) => (
  <Grid item xs={6} md={4} container>
    <Typography style={{ fontSize: 18 }}>{`${item}:  `}</Typography>
    <Typography style={{ fontSize: 18, marginLeft: 6 }}>{value}</Typography>
  </Grid>
);
